import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OnboardingRoutingModule } from './onboarding-routing.module';
import { OnboardingComponent } from './onboarding.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule,MatCardModule, MatDividerModule, MatFormFieldModule, MatIconModule, MatMenuModule, MatSelectModule, MatTableModule, MatTabsModule } from '@angular/material';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { AddOnsListModule } from '../projects/project-create/tabs/add-ons-list/add-ons-list.module';
import { AddOnsModule } from '../projects/project-create/tabs/add-ons/add-ons.module';
import { TableModule } from 'primeng/table';
import { DropdownModule, MultiSelectModule } from 'primeng/primeng';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [OnboardingComponent],
  imports: [
    CommonModule,
    OnboardingRoutingModule,
    TableModule,
    MultiSelectModule,
    FormsModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    MatTabsModule,
    MatCardModule,
    BrowserAnimationsModule
    // NgxChartsModule,
    // FuseSharedModule,
    // FuseSidebarModule,
    // FuseWidgetModule,
    // RoundProgressModule,
    // AddOnsModule,
    // AddOnsListModule
    
  ]
})
export class OnboardingModule { }
